import Swal from "sweetalert2";

export const injectCustomStyles = () => {
  if (!document.getElementById("sweetalert-custom-styles")) {
    const style = document.createElement("style");
    style.id = "sweetalert-custom-styles";
    style.textContent = `
      .custom-swal-popup {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      }
      
      .custom-swal-popup .swal2-actions {
        gap: 10px;
        margin: 1.25em auto 0;
        justify-content: center;
      }
      
      .custom-swal-popup .custom-btn {
        padding: 8px 20px;
        border-radius: 4px;
        font-weight: 400;
        font-size: 14px;
        line-height: 1.4;
        min-width: 80px;
        border: 1px solid;
        cursor: pointer;
        text-align: center;
        display: inline-block;
        text-decoration: none;
        margin: 0;
      }
      
      .custom-swal-popup .custom-btn-primary {
        background-color: #E39435;
        border-color: #E39435;
        color: white;
      }
      
      .custom-swal-popup .custom-btn-primary:hover {
        background-color: #E39435;
        border-color: #E39435;
      }
      
      .custom-swal-popup .custom-btn-secondary {
        background-color: #6c757d;
        border-color: #6c757d;
        color: white;
      }
      
      .custom-swal-popup .custom-btn-secondary:hover {
        background-color: #545b62;
        border-color: #545b62;
      }
      
      .custom-swal-popup .custom-btn-success {
        background-color: #28a745;
        border-color: #28a745;
        color: white;
      }
      
      .custom-swal-popup .custom-btn-success:hover {
        background-color: #1e7e34;
        border-color: #1e7e34;
      }
      
      .custom-swal-popup .custom-btn-danger {
        background-color: #dc3545;
        border-color: #dc3545;
        color: white;
      }
      
      .custom-swal-popup .custom-btn-danger:hover {
        background-color: #c82333;
        border-color: #c82333;
      }
    `;
    document.head.appendChild(style);
  }
};

export const injectCustomStyles2 = () => {
  if (!document.getElementById("sweetalert-custom-styles")) {
    const style = document.createElement("style");
    style.id = "sweetalert-custom-styles";
    style.textContent = `
      /* Target SweetAlert popup directly */
      .swal2-popup {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
      }
      
      .swal2-actions {
        gap: 8px !important;
        margin: 1.25em auto 0 !important;
        justify-content: center !important;
        display: flex !important;
      }
      
      /* Target Bootstrap button classes used in SweetAlert */
      .swal2-popup .btn {
        padding: 8px 20px !important;
        border-radius: 4px !important;
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 1.4 !important;
        min-width: 80px !important;
        border: 1px solid !important;
        cursor: pointer !important;
        text-align: center !important;
        display: inline-block !important;
        text-decoration: none !important;
        margin: 0 !important;
      }
      
      .swal2-popup .btn-success {
        background-color: #28a745 !important;
        border-color: #28a745 !important;
        color: white !important;
      }
      
      .swal2-popup .btn-success:hover {
        background-color: #1e7e34 !important;
        border-color: #1e7e34 !important;
      }
      
      .swal2-popup .btn-danger {
        background-color: #dc3545 !important;
        border-color: #dc3545 !important;
        color: white !important;
      }
      
      .swal2-popup .btn-danger:hover {
        background-color: #c82333 !important;
        border-color: #c82333 !important;
      }
      
      /* Alternative: Target SweetAlert button classes directly */
      .swal2-confirm.btn-success {
        background-color: #28a745 !important;
        border-color: #28a745 !important;
        color: white !important;
      }
      
      .swal2-cancel.btn-danger {
        background-color: #dc3545 !important;
        border-color: #dc3545 !important;
        color: white !important;
      }

      /* Ensure gap between any SweetAlert buttons */
      .swal2-popup .swal2-confirm {
        margin-left: 4px !important;
      }
      
      .swal2-popup .swal2-cancel {
        margin-right: 4px !important;
      }
    `;
    document.head.appendChild(style);
  }
};

export const alertMessage = (title: string, text: string) => {
  injectCustomStyles();

  const swalWithCustomButtons = Swal.mixin({
    customClass: {
      popup: "custom-swal-popup",
      confirmButton:
        title === "Error!"
          ? "custom-btn custom-btn-danger"
          : title === "Success!"
          ? "custom-btn custom-btn-success"
          : "custom-btn custom-btn-primary",
    },
    buttonsStyling: false,
  });

  swalWithCustomButtons
    .fire({
      title: title,
      text: text,
      icon:
        title === "Error!"
          ? "error"
          : title === "Success!"
          ? "success"
          : title === "Warning!"
          ? "warning"
          : "question",
      confirmButtonText: "OK",
      reverseButtons: true,
      customClass: {
      confirmButton: title === "Error!"? "custom-error-btn" : "custom-confirm-btn",
      cancelButton: "custom-cancel-btn",
    },
    })
    .then((result: any) => {});
};

export const alertMessageWithCancel = async (
  title: string,
  text: string,
  confirmButtonText?: string,
  cancelButtonText?: string
): Promise<boolean> => {

  const swalWithCustomButtons = Swal.mixin({
   customClass: {
      confirmButton: title === "Error!"? "custom-error-btn" : "custom-confirm-btn",
      cancelButton: "custom-cancel-btn",
    },
    buttonsStyling: false,
  });

  const result = await swalWithCustomButtons.fire({
    title: title,
    text: text,
    icon:
      title === "Error!"
        ? "error"
        : title === "Success!"
        ? "success"
        : "warning",
    confirmButtonText: confirmButtonText || "OK",
    cancelButtonText: cancelButtonText || "Cancel",
    showCancelButton: true,
    reverseButtons: false, // Keep OK on the right, Cancel on the left
    customClass: {
      confirmButton: title === "Error!"? "custom-error-btn" : "custom-confirm-btn",
      cancelButton: "custom-cancel-btn",
    },
  });

  return result.isConfirmed;
};
